<template>
    <div class="col-md-12">
        <form @submit.prevent="addStepAddress">

            <div class="">
                <div class="h2">Add new address</div>
                <div class="">
                    <div class="container-fluid bg-light py-3">
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2" :class="address.nickname=='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required class="form-control border-0 py-0 shadow-none form-input" placeholder="Warehouse name"
                                                   v-model="address.nickname">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2" :class="address.name=='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required class="form-control  border-0 py-0 shadow-none form-input" placeholder="Address name"
                                                   v-model="address.name">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2" :class="address.zip=='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required class="form-control border-0 py-0 shadow-none form-input" placeholder="Zip"
                                                   v-model="address.zip">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2" :class="address.street=='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required class="form-control border-0 py-0 shadow-none form-input" placeholder="Street"
                                                   v-model="address.street">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2" :class="address.city=='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required class="form-control border-0 py-0 shadow-none form-input" placeholder="City"
                                                   v-model="address.city">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                         <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2" :class="address.country_id=='' && isSubmit? 'border-danger':''">
                                            <select v-model="address.country_id" class="form-control border-0 py-0 shadow-none pr-5">
                                                <option value="1" selected>Denmark</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary btn-lg"  @click="validation()">Save</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

         <a href="/settings/step-addresses" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

    </div>
</template>

<script>

export default {
    name: "StepAddressCreate",
    data() {
        return {
            address: {},
            isSubmit: false
        }
    },
    methods: {
        validation(){
            this.isSubmit = true;
        },
        addStepAddress() {
            axios.post('/settings/store-step-address', this.address).then((response) => {
                window.location.href = `/settings/step-addresses`;
            }).catch(err => console.log(err))
        }
    }
}

</script>
